import React, { useEffect, useState } from "react";
import { Link, useNavigate, useHistory } from "react-router-dom";
import productImg from "../assets/img/product/product_1_1.jpg";
import productThumbImg from "../assets/img/product/product_thumb_1_1.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "./header";
import axios from "axios";
import Footer from "./footer";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ProductDetail() {
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [isInCart, setIsInCart] = useState(false); // New state
  const [rentalStartDate, setRentalStartDate] = useState(new Date());
  const [rentalEndDate, setRentalEndDate] = useState(new Date());
  const [showOptions, setShowOptions] = useState(false); // New state to control visibility
  const [selectedAction, setSelectedAction] = useState(null); // 'cart' or 'wishlist'
  const [cartItemDetails, setCartItemDetails] = useState(null); // New state
  const product_id = localStorage.getItem("product_id");
  const isBuyOutOfStock = products.saleStock <= 0;
  const isRentOutOfStock = products.rentalStock <= 0;
  const history = useHistory();

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API_URL}/products/${product_id}`);
      setProducts(response.data);
    } catch (error) {
      // console.error("Failed to fetch products:", error);
      // setProducts([]);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleAddToCart = () => {
    if (!products) return;
    if (selectedOption === "buy" && quantity > products.saleStock) {
      Swal.fire("Error", "Not enough stock available for purchase.", "error");
      return;
    }
    if (selectedOption === "rent" && products.rentalStock <= 0) {
      Swal.fire("Error", "Not enough stock available for rent.", "error");
      return;
    }

    const timeDiff = rentalEndDate.getTime() - rentalStartDate.getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const rentalDays = diffDays > 0 ? diffDays : 1;

    const cartItem = {
      productId: products.id,
      name: products.name,
      price:
        selectedOption === "buy"
          ? products.salePrice * quantity
          : selectedOption === "rent"
          ? products.rentalPrice
          : products.salePrice,
      quantity: selectedOption === "buy" ? quantity : rentalDays,
      type:
        selectedOption === "buy"
          ? "buy"
          : selectedOption === "rent"
          ? "rent"
          : "buy",
      image: products.image,
    };
    console.log({cartItem});

    if (selectedOption === "rent") {
      cartItem.rentalStartDate = rentalStartDate.toISOString();
      cartItem.rentalEndDate = rentalEndDate.toISOString();
    }

    // Get existing cart items from localStorage
    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    const existingCart = JSON.parse(localStorage.getItem(cartKey) || "[]");

    // Check if item already exists in cart
    const existingItemIndex = existingCart.findIndex(
      (item) =>
        item.productId === cartItem.productId && item.type === cartItem.type
    );

    if (existingItemIndex > -1) {
      // Update quantity if item exists
      existingCart[existingItemIndex].quantity += cartItem.quantity;
    } else {
      // Add new item if it doesn't exist
      existingCart.push(cartItem);
    }

    // Save updated cart to localStorage
    const updatedCart = existingCart;
    // console.log({ updatedCart });
    localStorage.setItem(cartKey, JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated")); // Dispatch event

    Swal.fire({
      title: "Success!",
      text: "Product added to cart",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });
    setShowOptions(false); // Hide options after adding to cart
    setQuantity(1); // Reset quantity
    setRentalStartDate(new Date());
    setRentalEndDate(new Date());
    setSelectedOption("buy"); // Reset option
    setSelectedAction(null); // Reset selected action
    setIsInCart(true); // Update cart status
    setCartItemDetails(cartItem); // Update cart item details
  };

  return (
    <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>
      {/* Preloader */}
      {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
          <img src="assets/img/logo.svg" alt="img" />
          <div className="heart-rate">
            <img src="assets/img/shape/preloader.svg" alt="" />

            <div className="fade-in"></div>

            <div className="fade-out"></div>
          </div>
        </div>
      </div> */}
      {/* Product Lightbox */}
      <div id="QuickView" className="white-popup mfp-hide">
        <div className="container bg-white">
          <div className="row gx-60">
            <div className="col-lg-6">
              <div className="product-big-img">
                <div className="img">
                  <img
                    src="assets/img/product/product_1_1.jpg"
                    alt="Product Image1"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="product-about">
                <p className="price">rentalPrice ₹ {products.salePrice}</p>
                <h2 className="product-title">{products.name}</h2>
                <div className="product-rating">
                  <div
                    className="star-rating"
                    role="img"
                    aria-label="Rated 5.00 out of 5"
                  >
                    {/* <span style={{ width: "100%" }}>
                      Rated <strong className="rating">5.00</strong> out of 5
                      based on <span className="rating">1</span> customer rating
                    </span> */}
                  </div>
                  <Link
                    to="shop-details.html"
                    className="woocommerce-review-link"
                  >
                    (<span className="count">3</span> customer reviews)
                  </Link>
                </div>
                <p className="text">
                  A device for measuring blood pressure is a medical device that
                  helps individuals monitor their blood pressure levels at home.
                  The user places the cuff on their arm, presses a button to
                  inflate it, and the device measures the pressure in the
                  arteries as the cuff slowly deflates.
                </p>
                <div className="checklist style4">
                  <ul>
                    <li>
                      {" "}
                      <i className="fa-regular fa-ship fa-fw"></i>Estimate
                      delivery times: 12-26 days (International), 3-6 days
                      (United States).
                    </li>
                    <li>
                      <i className="fa-solid fa-rotate-left"></i>Return within 7
                      days of purchase. Duties & taxes are non-refundable.
                    </li>
                  </ul>
                </div>
                <div className="actions">
                  <div className="quantity">
                    <input
                      type="number"
                      className="qty-input"
                      step="1"
                      min="1"
                      max="100"
                      name="quantity"
                      value="1"
                      title="Qty"
                    />
                    <button className="quantity-plus qty-btn">
                      <i className="far fa-chevron-up"></i>
                    </button>
                    <button className="quantity-minus qty-btn">
                      <i className="far fa-chevron-down"></i>
                    </button>
                  </div>
                  <button className="th-btn">Add to Cart</button>
                </div>
                <div className="product_meta">
                  {/* <span className="sku_wrapper">
                    SKU: <span className="sku">Medical-1254</span>
                  </span> */}
                  <span className="posted_in">
                    Category:{" "}
                    <Link to="shop.html" rel="tag">
                      Device, Heatlhcare
                    </Link>
                  </span>
                  {/* <span>
                    Tags: <Link to="shop.html">Medical Device</Link>
                  </span> */}
                  <span>
                    Availability: <Link to="shop.html">In Stock: 25</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button title="Close (Esc)" type="button" className="mfp-close">
            ×
          </button>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image4"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image6"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image8"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image8"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image9"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image9"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image10"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="home-medical-clinic.html">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        className="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Product Details</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Product Details</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Product Details */}
      <section className="product-details overflow-hidden  space-top space-extra-bottom">
        <div className="container">
          <div className="row gx-60">
            <div className="col-lg-6">
              <div className="productSlide">
                <div
                  className="swiper th-slider"
                  id="productSlide1"
                  data-slider-options='{"effect":"slide","spaceBetween":0,"thumbs":{"swiper":".product-grid2-thumb"},"breakpoints":{"0":{"autoHeight":true},"576":{"autoHeight":false}}}'
                >
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <img
                        src={`https://sunrise-backend.sunrisemeditechsystems.com${products.image}`}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                {/* <button
                  data-slider-prev="#productSlide1"
                  className="slider-arrow style3 slider-prev"
                >
                  <i className="far fa-arrow-left"></i>
                </button>
                <button
                  data-slider-next="#productSlide1"
                  className="slider-arrow style3 slider-next"
                >
                  <i className="far fa-arrow-right"></i>
                </button> */}
                {/* <div className="swiper th-slider product-grid2-thumb" data-slider-options='{"effect":"slide","slidesPerView":"3","spaceBetween":32,"breakpoints":{"0":{"slidesPerView":3},"576":{"slidesPerView":"3"}}}' data-slider-tab="#productSlide1">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <img src="assets/img/product/single-image-1.jpg" alt=""/>
                                </div>
                                <div className="swiper-slide">
                                    <img src="assets/img/product/single-image-2.jpg" alt=""/>
                                </div>
                                <div className="swiper-slide">
                                    <img src="assets/img/product/single-image-3.jpg" alt=""/>
                                </div>

                            </div>
                        </div> */}
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="product-about">
                <p className="price">₹ {products.salePrice * quantity}</p>
                <h4 className="product-title">{products.name}</h4>
                <div className="product-rating">
                  <div
                    className="star-rating"
                    role="img"
                    aria-label="Rated 5.00 out of 5"
                  >
                    <span style={{ width: "100%" }}>
                      Rated <strong className="rating">5.00</strong> out of 5
                      based on <span className="rating">1</span> customer rating
                    </span>
                  </div>
                  <Link
                    to="shop-details.html"
                    className="woocommerce-review-link"
                  >
                    (<span className="count">3</span>
                    customer reviews)
                  </Link>
                </div>
                <p className="text">{products.description}</p>
                {/* <div className="checklist style4">
                            <ul>
                                <li> <i className="fa-regular fa-ship fa-fw"></i>Estimate delivery times: 12-26 days
                                    (International), 3-6 days (United States).</li>
                                <li><i className="fa-solid fa-rotate-left"></i>Return within 7 days of purchase. Duties & taxes
                                    are non-refundable.</li>
                            </ul>
                        </div> */}
                {/* Buy/Rent Options */}
                <div className="d-flex align-items-center mb-3">
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      className={`theme-btn-1 btn btn-effect-1 ${
                        selectedOption === "buy" ? "" : "btn-outline"
                      }`}
                      style={{
                        marginRight: "10px",
                        background: "#0A9A73",
                        padding: "10px 22px",
                        borderRadius: "8px"
                      }}
                      onClick={() => setSelectedOption("buy")}
                    >
                      Buy
                    </button>
                    {products.isRentalAvailable && (
                      <button
                        type="button"
                        className={`theme-btn-1 btn btn-effect-1 ${
                          selectedOption === "rent" ? "" : "btn-outline"
                        }`}
                        style={{
                          padding: "10px 22px",
                          borderRadius: "8px"
                        }}
                        onClick={() => setSelectedOption("rent")}
                      >
                        Rent
                      </button>
                    )}
                  </div>
                </div>
                {/* Date Pickers for Rent */}
                {selectedOption === "rent" && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="me-3">
                      <label className="fw-bold">From:</label>
                      <DatePicker
                        selected={rentalStartDate}
                        onChange={(date) => setRentalStartDate(date)}
                        selectsStart
                        startDate={rentalStartDate}
                        endDate={rentalEndDate}
                        className="form-control input-date"
                      />
                    </div>
                    <div>
                      <label className="fw-bold">To:</label>
                      <DatePicker
                        selected={rentalEndDate}
                        onChange={(date) => setRentalEndDate(date)}
                        selectsEnd
                        startDate={rentalStartDate}
                        endDate={rentalEndDate}
                        minDate={rentalStartDate}
                        className="form-control input-date"
                      />
                    </div>
                  </div>
                )}

                <div className="actions">
                  {(
                    selectedOption === "buy") && (
                    <>
                      <div className="quantity">
                        <input
                          type="number"
                          className="qty-input"
                          step="1"
                          min="1"
                          max="100"
                          name="quantity"
                          value={quantity}
                          title="Qty"
                        />
                        <button
                          className="quantity-plus qty-btn"
                          onClick={() =>
                            setQuantity((prev) =>
                              prev < products?.saleStock ? prev + 1 : prev
                            )
                          }
                        >
                          <i className="far fa-chevron-up"></i>
                        </button>
                        <button
                          className="quantity-minus qty-btn"
                          onClick={() =>
                            setQuantity((prev) => (prev > 1 ? prev - 1 : 1))
                          }
                        >
                          <i className="far fa-chevron-down"></i>
                        </button>
                      </div>
                    </>
                  )}
                  <button
                    className="theme-btn-1 btn btn-effect-1"
                    style={{borderRadius:"8px"}}
                    title={isInCart ? "Go to Cart" : "Add to Cart"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (isBuyOutOfStock && selectedOption === "buy") return;
                      if (isRentOutOfStock && selectedOption === "rent") return;
                      isInCart ? history.push("/cart") : handleAddToCart();
                    }}
                    // style={{
                    //   pointerEvents:
                    //     (selectedOption === "buy" && isBuyOutOfStock) ||
                    //     (selectedOption === "rent" && isRentOutOfStock)
                    //       ? "none"
                    //       : "auto",
                    //   opacity:
                    //     (selectedOption === "buy" && isBuyOutOfStock) ||
                    //     (selectedOption === "rent" && isRentOutOfStock)
                    //       ? 0.5
                    //       : 1,
                    // }}
                  >
                    {isInCart ? "Go to Cart" : "Add to Cart"}
                  </button>
                  {/* <button className="th-btn">Add to Cart</button> */}
                </div>
                <div className="product_meta">
                  {/* <span className="sku_wrapper">SKU: <span className="sku">Medical-1254</span></span> */}
                  <span className="posted_in">
                    Category:{" "}
                    <Link to="shop.html" rel="tag">
                      {products.category}
                    </Link>
                  </span>
                  {/* <span>Tags: <Link to="shop.html">Medical Device</Link></span> */}
                  <span>
                    Availability:{" "}
                    <Link to="shop.html">In Stock: {products.saleStock}</Link>
                  </span>
                  <span>Sale Price: ₹ {products.salePrice * quantity}</span>
                  <span>Rental Price: ₹ {products.rentalPrice}</span>
                </div>
                <br />
                <br />
                {/* <div className="product-cards">
                  <p className="title">Guarantee safe checkout</p>
                  <img src="assets/img/shape/cards.png" alt="" />
                </div> */}
              </div>
            </div>
          </div>
          {/* <ul className="nav product-tab-style1" id="productTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link className="nav-link th-btn" id="description-tab" data-bs-toggle="tab" to="#description" role="tab" aria-controls="description" aria-selected="false">Description</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link className="nav-link th-btn" id="additional-tab" data-bs-toggle="tab" to="#additional" role="tab" aria-controls="additional" aria-selected="false">Additional Information</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link className="nav-link th-btn active" id="reviews-tab" data-bs-toggle="tab" to="#reviews" role="tab" aria-controls="reviews" aria-selected="true">Review (3)</Link>
                </li>
            </ul> */}
          <div className="tab-content" id="productTabContent">
            {/* <div className="tab-pane fade" id="description" role="tabpanel" aria-labelledby="description-tab">
                    <h3 className="box-title">Description</h3>
                    <p>A device for measuring blood pressure is a medical instrument designed to monitor the pressure of
                        blood flowing through the arteries. It consists of a cuff that is wrapped around the upper arm, a
                        pump to inflate the cuff, and a pressure gauge that indicates the pressure of the blood flow.
                        The device works by measuring the force of blood against the walls of the arteries during each
                        heartbeat, known as systolic pressure, and the pressure between beats, known as diastolic pressure.
                        Blood pressure is measured in millimeters of mercury (mmHg), and a healthy blood pressure reading is
                        typically considered to be around 120/80 mmHg.
                        There are various types of devices for measuring blood pressure, including manual devices that
                        require a stethoscope to listen for the heartbeat, and automated devices that use sensors to detect
                        the pulse and provide digital readings. Automated devices may be further classified as arm-cuff
                        monitors or wrist-cuff monitors.
                        Blood pressure monitors are an essential tool for individuals with hypertension, or high blood
                        pressure, as well as for those with other cardiovascular conditions. They can also be used by
                        healthcare professionals in clinical settings to monitor patients' blood pressure during routine
                        check-ups or when assessing symptoms.
                        When selecting a blood pressure monitoring device, it is important to consider factors such as
                        accuracy, ease of use, and reliability. Many modern devices may also include additional features
                        such as memory storage, Bluetooth connectivity, and mobile apps for tracking and analyzing blood
                        pressure data over time. </p>

                </div> */}
            <div
              className="tab-pane fade"
              id="additional"
              role="tabpanel"
              aria-labelledby="additional-tab"
            >
              <h3 className="box-title">Additional</h3>
              <p>
                A device for measuring blood pressure is a medical instrument
                designed to monitor the pressure of blood flowing through the
                arteries. It consists of a cuff that is wrapped around the upper
                arm, a pump to inflate the cuff, and a pressure gauge that
                indicates the pressure of the blood flow. The device works by
                measuring the force of blood against the walls of the arteries
                during each heartbeat, known as systolic pressure, and the
                pressure between beats, known as diastolic pressure. Blood
                pressure is measured in millimeters of mercury (mmHg), and a
                healthy blood pressure reading is typically considered to be
                around 120/80 mmHg. There are various types of devices for
                measuring blood pressure, including manual devices that require
                a stethoscope to listen for the heartbeat, and automated devices
                that use sensors to detect the pulse and provide digital
                readings. Automated devices may be further classified as
                arm-cuff monitors or wrist-cuff monitors. Blood pressure
                monitors are an essential tool for individuals with
                hypertension, or high blood pressure, as well as for those with
                other cardiovascular conditions. They can also be used by
                healthcare professionals in clinical settings to monitor
                patients' blood pressure during routine check-ups or when
                assessing symptoms. When selecting a blood pressure monitoring
                device, it is important to consider factors such as accuracy,
                ease of use, and reliability. Many modern devices may also
                include additional features such as memory storage, Bluetooth
                connectivity, and mobile apps for tracking and analyzing blood
                pressure data over time.{" "}
              </p>
            </div>
            <div
              className="tab-pane fade show active"
              id="reviews"
              role="tabpanel"
              aria-labelledby="reviews-tab"
            >
              <div className="woocommerce-Reviews">
                <div className="th-comments-wrap ">
                  {/* <ul className="comment-list">
                                <li className="review th-comment-item">
                                    <div className="th-post-comment">
                                        <div className="comment-avater">
                                            <img src="assets/img/blog/comment-author-1.jpg" alt="Comment Author"/>
                                        </div>
                                        <div className="comment-content">
                                            <h4 className="name">
                                                Mariya Dsuza</h4>
                                            <span className="commented-on"><i className="far fa-clock"></i>22 April, 2025</span>
                                            <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                                                <span style={{width:"100%"}}>Rated <strong className="rating">5.00</strong> out of 5 based on <span className="rating">1</span> customer rating</span>
                                            </div>
                                            <p className="text">A device for measuring blood pressure is a medical device that helps individuals monitor their blood pressure levels at home.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="review th-comment-item">
                                    <div className="th-post-comment">
                                        <div className="comment-avater">
                                            <img src="assets/img/blog/comment-author-2.jpg" alt="Comment Author"/>
                                        </div>
                                        <div className="comment-content">
                                            <h4 className="name">Michel Phelops</h4>
                                            <span className="commented-on"><i className="far fa-clock"></i>26 April, 2025</span>
                                            <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                                                <span style={{width:"100%"}}>Rated <strong className="rating">5.00</strong> out of 5 based on <span className="rating">1</span> customer rating</span>
                                            </div>
                                            <p className="text">A device for measuring blood pressure is a medical device that helps individuals monitor their blood pressure levels at home.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="review th-comment-item">
                                    <div className="th-post-comment">
                                        <div className="comment-avater">
                                            <img src="assets/img/blog/comment-author-3.jpg" alt="Comment Author"/>
                                        </div>
                                        <div className="comment-content">
                                            <h4 className="name">Hamilton Barason</h4>
                                            <span className="commented-on"><i className="far fa-clock"></i>26 April, 2025</span>
                                            <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                                                <span style={{width:"100%"}}>Rated <strong className="rating">5.00</strong> out of 5 based on <span className="rating">1</span> customer rating</span>
                                            </div>
                                            <p className="text">A device for measuring blood pressure is a medical device that helps individuals monitor their blood pressure levels at home.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="review th-comment-item">
                                    <div className="th-post-comment">
                                        <div className="comment-avater">
                                            <img src="assets/img/blog/comment-author-4.jpg" alt="Comment Author"/>
                                        </div>
                                        <div className="comment-content">
                                            <h4 className="name">Adison Smith</h4>
                                            <span className="commented-on"><i className="far fa-clock"></i>26 April, 2025, 2025</span>
                                            <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                                                <span style={{width:"100%"}}>Rated <strong className="rating">5.00</strong> out of 5 based on <span className="rating">1</span> customer rating</span>
                                            </div>
                                            <p className="text">A device for measuring blood pressure is a medical device that helps individuals monitor their blood pressure levels at home.</p>
                                        </div>
                                    </div>
                                </li>
                            </ul> */}
                </div>
                {/* <!-- Comment Form --> */}
                {/* <div className="th-comment-form ">
                            <div className="form-title">
                                <h3 className="blog-inner-title ">Add a review</h3>
                            </div>
                            <div className="row">
                                <div className="form-group rating-select d-flex align-items-center">
                                    <label>Your Rating</label>
                                    <p className="stars">
                                        <span>
                                            <Link className="star-1" to="#">1</Link>
                                            <Link className="star-2" to="#">2</Link>
                                            <Link className="star-3" to="#">3</Link>
                                            <Link className="star-4" to="#">4</Link>
                                            <Link className="star-5" to="#">5</Link>
                                        </span>
                                    </p>
                                </div>
                                <div className="col-12 form-group">
                                    <textarea placeholder="Write a Message" className="form-control"></textarea>
                                    <i className="text-title far fa-pencil-alt"></i>
                                </div>
                                <div className="col-md-6 form-group">
                                    <input type="text" placeholder="Your Name" className="form-control"/>
                                    <i className="text-title far fa-user"></i>
                                </div>
                                <div className="col-md-6 form-group">
                                    <input type="text" placeholder="Your Email" className="form-control"/>
                                    <i className="text-title far fa-envelope"></i>
                                </div>
                                <div className="col-12 form-group">
                                    <input id="reviewcheck" name="reviewcheck" type="checkbox"/>
                                    <label for="reviewcheck">Save my name, email, and website in this browser for the next time I comment.<span className="checkmark"></span></label>
                                </div>
                                <div className="col-12 form-group mb-0">
                                    <button className="th-btn">Post Review</button>
                                </div>
                            </div>
                        </div> */}
              </div>
            </div>
          </div>

          {/* Related Product   */}
          {/* <div className="space-extra-top mb-30">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-auto">
                        <span className="sub-title">shop products</span>
                        <h2 className="sec-title text-center"><span className="fw-normal">Your Might</span> Like This</h2>
                    </div>
                </div>
                <div className="swiper th-slider has-shadow" id="productSlider1" data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"1200":{"slidesPerView":"3"}}}'>
                    <div className="swiper-wrapper">

                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_1.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Puregen Labs Meclizine</Link></h3>
                                    <span className="price">$55.00<del>$65.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_2.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Pranarom Pure Essential Oil</Link></h3>
                                    <span className="price">$15.00<del>$25.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_3.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Pediatric Stethoscope</Link></h3>
                                    <span className="price">$30.00<del>$35.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_4.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Puregen Labs Allergy Relief</Link></h3>
                                    <span className="price">$55.00<del>$65.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_5.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Digital Thermometer</Link></h3>
                                    <span className="price">$15.99<del>$25.99</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_6.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Fingertip Pulse Oximeter</Link></h3>
                                    <span className="price">$25.00<del>$35.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_7.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Medical Shower & Bath Chair</Link></h3>
                                    <span className="price">$35.00<del>$45.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="swiper-slide">
                            <div className="th-product product-grid">
                                <div className="product-img">
                                    <img src="assets/img/product/product_1_8.jpg" alt="Product Image"/>
                                    <div className="actions">
                                        <Link to="#QuickView" className="icon-btn popup-content"><i className="far fa-eye"></i></Link>
                                        <Link to="cart.html" className="icon-btn"><i className="far fa-cart-plus"></i></Link>
                                        <Link to="wishlist.html" className="icon-btn"><i className="far fa-heart"></i></Link>
                                    </div>
                                </div>
                                <div className="product-content">
                                    <h3 className="product-title"><Link to="shop-details.html">Blood Pressure Monitor</Link></h3>
                                    <span className="price">$25.00<del>$35.00</del></span>
                                    <div className="btn-group justify-content-between">
                                        <div className="quantity">
                                            <span>Quantity</span>
                                            <input type="number" className="qty-input" step="1" min="1" max="100" name="quantity" value="1" title="Qty"/>
                                        </div>
                                        <Link to="shop-details.html" className="th-btn">ADD TO CART <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="d-block d-md-none mt-40 text-center">
                    <div className="icon-box">
                        <button data-slider-prev="#productSlider1" className="slider-arrow default"><i className="far fa-arrow-left"></i></button>
                        <button data-slider-next="#productSlider1" className="slider-arrow default"><i className="far fa-arrow-right"></i></button>
                    </div>
                </div>
            </div> */}
        </div>
      </section>
      {/* Footer Area */}
      <Footer />
    </>
  );
}
